import React from "react";

const ComplianceReports = () => {
    return (
        <div className="container">
            <h1>Compliance Reports</h1>
            <p>
                Generate detailed compliance reports to ensure your organization meets
                industry standards. Stay ahead in regulatory adherence with minimal effort.
            </p>
            <p>
                Features:
                <ul>
                    <li>Automated compliance tracking</li>
                    <li>Customizable report formats</li>
                    <li>Integration with external regulatory tools</li>
                </ul>
            </p>
        </div>
    );
};

export default ComplianceReports;
